import { Button } from 'components/lib';
import RFITableFilterPopover from 'components/RFITableFilterPopover';
import React, { useContext } from 'react';
import { Project } from 'records/Project';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import AppStoreContext from 'contexts/AppStoreContext';
import { useTranslator } from '@bluebeam/react-i18n';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import RFIExportButton from './RFIExportButton';
import RFIListSearch from './RFIListSearch';

interface Props extends WithAppStoreProps, RouteComponentProps {
  onCreateRFI: () => void;
}

const RFISubheader = (props: Props) => {
  const { state } = useContext(AppStoreContext);
  const { rfis, queriedRFIs, projects, selectedProject } = state;

  const handleCreateRFI = (): void => {
    props.onCreateRFI();
  };

  const { permissions } = projects.get(selectedProject, new Project());
  const { translate } = useTranslator(['rfiPage']);

  return (
    <div className="row justify-between items-center mb4">
      <div className="mr4 font-size-5 medium color-gray-9">
        {queriedRFIs.size !== rfis.size
          ? `${translate('rfiPage:results')} (${queriedRFIs.size})`
          : `${translate('rfiPage:allRFIs')} (${rfis.size})`}
      </div>
      <div className="row">
        <div className="mr4">
          <RFIExportButton />
        </div>
        <RFITableFilterPopover />
        <div className="mr4">
          <RFIListSearch />
        </div>
        {permissions.createRfi ? (
          <Button
            id="rfi-page-create-rfi-btn"
            variant="primary"
            size="small"
            onClick={handleCreateRFI}
          >
            {translate('rfiPage:createRFI')}
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default withRouter(withAppStore<Props>(RFISubheader));
